/**
 * Generates a unique ID
 */
export function generateId(): string {
  // For database IDs that require UUID format
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // Fallback for older browsers or non-database IDs
  return (
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15)
  );
}
